import React, { Component } from 'react';

export class NavigationBarColor extends Component {
    render() {
        return (
            <></>
        )
    }
}

export default NavigationBarColor;